export const introduce = {
  text: `### 使用方法
  + • 红色区域（指标 > 0.02）：高价格低信心，风险回报较低，往往是周期顶部。
  + • 绿色区域（指标 < 0.002）：低价格高信心，风险回报极高，往往是周期底部。
  
  ### 指标原理
  + 持有机会成本：持有比特币的机会成本是可以量化的（如果今天在市场上持有48000美元的比特币，为了继续持有，投资者放弃了48000美元），通过将美元长期的总金额相加，得出在比特币网络生命周期内决定持有而不是出售的累积机会成本（缩小到单个比特币的价值）。
  + 储备风险 = 价格 ÷ 持有机会成本
  + 储备风险用于量化长期持有者对比特币的信心，探究了持有信心和风险回报的关系。
  + 更多介绍见：[关于储备风险的文章](https://www.kanaandkatana.com/valuation-depot-contents/2019/5/30/exploration-of-bitcoin-days-destroyed)
  
  ### 创作者
  该指标由 [Ikigai资产管理公司](https://www.ikigai.fund/) 的 [Hans Hauge](https://twitter.com/hansthered/media) 创建。`,
  height: 1480,
};
